import { AfterViewInit, Component, ElementRef, Input, OnInit, Output, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ProjectStatusDialogComponent } from '../right-side-opener/project-status-dialog.component';
import { PreviousMeetingsComponent } from '../../components/previous-meetings/previous-meetings.component';
import { upComingMeeting } from '../../models/upcomingMeetingModel';
import { DashboardService } from 'src/app/service/dashboard.service';
import { MatPaginator } from '@angular/material/paginator';
import { MeetingDataSource } from 'src/app/service/meeting.datasource';
import { debounceTime, distinctUntilChanged, tap } from 'rxjs/operators';
import { MeetingResponse } from 'src/app/models/basicMeetingModel';
import { MatTableDataSource } from '@angular/material/table';

//UI Team change
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { fromEvent, Observable } from 'rxjs';
import { MeetingService } from 'src/app/service/meeting.service';
import { SideNavServiceService } from 'src/app/service/side-nav-service.service';
import { DeleteMeetingPopupComponent } from '../delete-meeting-popup/delete-meeting-popup.component';
import { ScheduleMeetingPopupComponent } from '../schedule-meeting-popup/schedule-meeting-popup.component';
import { CancelMeetingPopupComponent } from '../cancel-meeting-popup/cancel-meeting-popup.component';
import { WebsocketTransferService } from 'src/app/service/websocket-transfer.service';

import {
  BreakpointObserver,
  Breakpoints,
  BreakpointState
} from '@angular/cdk/layout';
import { Globals } from 'src/app/service/global';
import { MatInput } from '@angular/material/input';
import { NotesAttachementDialogComponent } from '../notes-attachement-dialog/notes-attachement-dialog.component';
import { UntypedFormControl } from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import { ConfidentialDialogComponent } from '../confidential-dialog/confidential-dialog.component';
import { UtilityService } from 'src/app/service/utility.service';
import { PermissionService } from 'src/app/service/permission.service';
import { AttendeeService } from 'src/app/service/attendee.service';
import { environment } from 'src/environments/environment';
import { AgoraConfigService } from 'src/AgoraConfigService';

import { TableDialogComponent } from '../table-dialog/table-dialog.component';
import { CopymeetingComponent } from '../copymeeting/copymeeting.component';
import { NotHeldPopupComponent } from '../not-held-popup/not-held-popup.component';
import { FollowupMeetingPopupComponent } from '../followup-meeting-popup/followup-meeting-popup.component';
import { ViewMomDialogComponent } from '../view-mom-dialog/view-mom-dialog.component';

@Component({
  selector: 'app-document-meeting',
  templateUrl: './document-meeting.component.html',
  styleUrls: ['./document-meeting.component.css']
})
export class DocumentMeetingComponent implements AfterViewInit, OnInit {
  componentName = "Upcoming-Meeting"
  userName?: any;
  meetingList: any;
  options: any
  today: any
  currentDate: any
  disabled = false;
  compact = true;
  invertX = false;
  invertY = false;
  start = "START";
  join = "JOIN";
  isExtraSmall: Observable<BreakpointState> = this.breakpointObserver.observe(
    Breakpoints.XSmall
  );
  isMedium: Observable<BreakpointState> = this.breakpointObserver.observe(
    Breakpoints.Medium
  )
  isSmall: Observable<BreakpointState> = this.breakpointObserver.observe(
    Breakpoints.Small
  )
  matDialogRef!: MatDialogRef<DeleteMeetingPopupComponent>;


  @Input()
  deviceXs!: boolean;

  @Input()
  deviceSm!: boolean;

  @Input()
  deviceMd!: boolean;

  @Input()
  deviceLg!: boolean;

  @Input()
  deviceXl!: boolean;



  //UI Team change variable declaration
  meetingInfoData: any

  shown: 'native' | 'hover' | 'always' = 'native';
  xl = {
    panelClass: ['animate__animated', 'animate__slideInRight'],
    position: {
      left: "50%"
    },
    maxWidth: "100%",
    maxHeight: "100vh",
    width: "50%",
    height: "100vh",
    overflow: "hidden"
  }

  lg = {
    panelClass: ['animate__animated', 'animate__slideInRight'],
    disableClose: false,
    position: {
      left: "50%"
    },
    maxWidth: "100%",
    maxHeight: "100vh",
    width: "50%",
    height: "100vh",
    overflow: "hidden"
  }

  md = {
    panelClass: ['animate__animated', 'animate__slideInRight'],
    position: {
      left: "50%"
    },
    maxWidth: "100%",
    maxHeight: "100vh",
    width: "50%",
    height: "100vh",
    overflow: "hidden"
  }

  sm = {
    panelClass: ['animate__animated', 'animate__slideInRight'],
    position: {
      left: "20%"
    },
    width: "calc(100% - 100px)",
    height: "calc(100% - 0px)",
  }

  xs = {
    panelClass: ['animate__animated', 'animate__slideInRight'],
    position: {
      left: "20%"
    },
    width: "calc(100% - 0px)",
    height: "calc(100% - 0px)",
  }

  // displayedColumns = ["meetingTitle","meetingDate","meetingId","getdetails"];
  displayedColumns = ["meetingDate", "meetingTitle", "action", "getdetails"];
  meetingDatasource!: MeetingDataSource;
  @ViewChild(MatPaginator, { static: true })
  paginator!: MatPaginator;
  @ViewChild('input', { static: true })
  input!: ElementRef;
  @ViewChild('start', { static: true, read: MatInput })
  startDa!: MatInput
  @ViewChild('end', { static: true, read: MatInput })
  endDa!: MatInput
  docMeetingJSON: any;
  meetingJSON: any;
  isLoading: boolean = false;
  matDialogReference!: MatDialogRef<ScheduleMeetingPopupComponent>;
  matDialogCancel!: MatDialogRef<CancelMeetingPopupComponent>
  startFilterDate: any;
  endFilterDate: any;
  completed = false;
  calendar = new UntypedFormControl();
  isShown: boolean = false;
  imageZoomSrc: string = "";
  matDialogCopy!: MatDialogRef<CopymeetingComponent>;
  matDialogDelete!: MatDialogRef<DeleteMeetingPopupComponent>;
  matDialogNotHeld!: MatDialogRef<NotHeldPopupComponent>;
  matDialogRefrence!: MatDialogRef<FollowupMeetingPopupComponent>;
  constructor(private attendeeService: AttendeeService, private spinner: NgxSpinnerService, private globals: Globals, private readonly breakpointObserver: BreakpointObserver, private webTranService: WebsocketTransferService, private meetingService: MeetingService, private matDialog: MatDialog, private dialog: MatDialog, private dashboardService: DashboardService, private activatedRouter: ActivatedRoute, private router: Router, private sideNav: SideNavServiceService, private util: UtilityService, public sideNavService: SideNavServiceService, public permissionService: PermissionService) {

    this.imageZoomSrc = `${environment.contextPath}` + '/assets/icons8-zoom-24.png';
    this.docMeetingJSON = {
      "delay": "10",
      "displayConfig": this.globals.settingValuesList.PAST_MEETING_CONF,
      "meetingStatus": [
        27, 20, 677
      ],
      "startDelay": "10",
      "userId": localStorage.getItem("userId"),
      "startDate": "",
      "endDate": "",
      "isDocMeeting": "Y",
      "visitorTimezone": JSON.parse(localStorage.getItem('currentUser') || '{}')['timeszone']
    }
    this.meetingJSON = {
      "delay": "10",
      "displayConfig": this.globals.settingValuesList.UPCOMING_MEETING_CONF,
      // "meetingStatus": [
      //   18,648
      // ],
      "startDelay": "60",
      "userId": this.globals.userId,
      "startDate": "",
      "endDate": "",
      "visitorTimeZone": this.globals.vTimeZone,
      "filterCol": ""
    }
    this.userName = localStorage.getItem('userName');
  }
  loadMeetingInfo(meeting: any) {
    if (meeting.isConfidential == "Y") {
      let dialogRef = this.dialog.open(ConfidentialDialogComponent, {
        panelClass: ['animate__animated', 'animate__slideInRight'],
        disableClose: true,
        position: {
          left: "50%"
        },
        maxWidth: "100%",
        maxHeight: "100vh",
        width: "50%",
        data: { isConfidentialCheck: true, meetingObj: meeting, flag: true, viewMeetingInfo: true }
      })
      const mediumDialogSubscription = this.isMedium.subscribe(size => {
        if (size.matches) {
          dialogRef.updateSize('70vw', '100vh');
        }
      })
      const smallDialogSubscription = this.isExtraSmall.subscribe(size => {
        if (size.matches) {
          dialogRef.updateSize('100vw', '100vh');
        } else {
          dialogRef.updateSize('calc(100% - 50px)', '100vh');
        }
      });
      const smallSubscription = this.isSmall.subscribe(size => {
        if (size.matches) {
          dialogRef.updateSize('100vw', '100vh');
        }
      })
      dialogRef.afterClosed().subscribe(() => {
        smallDialogSubscription.unsubscribe();
        smallSubscription.unsubscribe();
        mediumDialogSubscription.unsubscribe();
      });
    }
    else {
      this.spinner.show();
      this.meetingService.fetchMeetingInfo(meeting.meetingId).subscribe(

        (meetingRes: any) => {
          // this.spinner.hide()
          this.meetingInfoData = meetingRes.body
          const d = this.dialog.open(ProjectStatusDialogComponent, {
            data: { meetingData: this.meetingInfoData, hide: false, hideUseTemplate: true },
            panelClass: ['animate__animated', 'animate__slideInRight', 'responsive-class'],
            disableClose: false,
            position: {
              left: "50%"
            },
            maxWidth: "100%",
            maxHeight: "100vh",
            width: "50%",
            height: "100vh"
          })
          const mediumDialogSubscription = this.isMedium.subscribe(size => {
            if (size.matches) {
              d.updateSize('70vw', '100vh');
            }
          })
          const smallDialogSubscription = this.isExtraSmall.subscribe(size => {
            if (size.matches) {
              d.updateSize('100vw', '100vh');
            } else {
              d.updateSize('calc(100% - 50px)', '100vh');
            }
          });
          const smallSubscription = this.isSmall.subscribe(size => {
            if (size.matches) {
              d.updateSize('100vw', '100vh');
            }
          })
          d.afterClosed().subscribe(() => {
            smallDialogSubscription.unsubscribe();
            smallSubscription.unsubscribe();
            mediumDialogSubscription.unsubscribe();
          });
          // this.commonService.shareDatatoService(this.meetingResponse);
          // this.setData();

          //this.cdr.markForCheck();
          //this.ngxSpinner.hide();
          this.spinner.hide();
        },
        err => {
          //
          //this.ngxSpinner.hide();
        }).add(() => {
          //Called when operation is complete (both success and error)
        });
    }
  }

  viewMeeting(meetingObj: any) {
 
    if (meetingObj.isConfidential == "Y") {
      let dialogRef = this.dialog.open(ConfidentialDialogComponent, {
        panelClass: ['animate__animated', 'animate__slideInRight'],
        disableClose: true,
        position: {
          left: "50%"
        },
        maxWidth: "100%",
        maxHeight: "100vh",
        width: "50%",
        data: { isConfidentialCheck: true, meetingObj: meetingObj, flag: true, meetingStartFlag: meetingObj.meetingStartFlag }
      })
      const mediumDialogSubscription = this.isMedium.subscribe(size => {
        if (size.matches) {
          dialogRef.updateSize('70vw', '100vh');
        }
      })
      const smallDialogSubscription = this.isExtraSmall.subscribe(size => {
        if (size.matches) {
          dialogRef.updateSize('100vw', '100vh');
        } else {
          dialogRef.updateSize('calc(100% - 50px)', '100vh');
        }
      });
      const smallSubscription = this.isSmall.subscribe(size => {
        if (size.matches) {
          dialogRef.updateSize('100vw', '100vh');
        }
      })
      dialogRef.afterClosed().subscribe((data) => {
        mediumDialogSubscription.unsubscribe()
        smallSubscription.unsubscribe()
        smallDialogSubscription.unsubscribe()
      });
    }
    else {
      var accessFlag = this.permissionService.checkUserRightsWithAlert(this.util.featureList.MEETINGS, this.util.permissionType.MODIFY);
      if (!accessFlag) {
        return;
      }
      if (meetingObj.isDummyLink != null && meetingObj.isDummyLink == "Y") {
        this.createRecurChildMeeting(meetingObj).then((res: any) => {
          if (res != null && res.body != null && res.body.meetingId != null) {
            if (res.body.meetingStartFlag == "Y") {
              this.startMeeting(res.body);
            } else {
              this.redirectToMeeting(res.body);
            }
          }
        });


      } else {
        if (meetingObj.meetingStartFlag == "Y") {
          this.startMeeting(meetingObj);
        } else {
          this.redirectToMeeting(meetingObj);
        }
      }
    }
  }

  createRecurChildMeeting(obj: any) {
    return new Promise((resolve, reject) => {
      var reqJson = {
        "recurDetailsId": obj.recurDetailsId,
        "meetingDateStr": obj.meetingDateStr,
        "meetingStartTime": obj.meetingStartTime,
        "orgCode": this.globals.orgCode,
        "userId": this.globals.userId,
        "visitorTimeZone": this.globals.vTimeZone
      }
 
      this.meetingService.createRecurChildMeeting(reqJson).subscribe(res => {
   
        resolve(res);
        // if(res!=null && res.body!=null && res.body.meetingId!=null){
        //   if(res.body.meetingStartFlag=="Y"){
        //     this.startMeeting(res.body);
        //   }else{
        //     this.redirectToMeeting(res.body);  
        //   }
        // }
      });
    });
  }


  ngDoCheck() {
    if (this.deviceXl || this.deviceLg) {
      this.displayedColumns = ["meetingDate", "meetingTitle", "action", "getdetails"]
    }
    else if (this.deviceSm || this.deviceXs || this.deviceMd) {
      this.displayedColumns = ["meetingDate", "responsiveMeetingTitle", "menu"]
    }
  }

  startMeeting(meeting: any) {
 
    var roleFlag = this.permissionService.checkRoleRightsWithNoAlert(this.util.featureList.MEETINGS, this.util.permissionType.READ);
 
    var accessFlag = this.permissionService.checkUserRightsWithAlert(this.util.featureList.MEETINGS, this.util.permissionType.MODIFY);
    
    if (!accessFlag) {
      return;
    }
    //
    if (meeting.isConfidential == "Y") {
      let dialogRef = this.dialog.open(ConfidentialDialogComponent, {
        panelClass: ['animate__animated', 'animate__slideInRight'],
        disableClose: true,
        position: {
          left: "50%"
        },
        maxWidth: "100%",
        maxHeight: "100vh",
        width: "50%",
        data: { isConfidentialCheck: true, meetingObj: meeting, "isMeetingRunning": true }
      })
      const mediumDialogSubscription = this.isMedium.subscribe(size => {
        if (size.matches) {
          dialogRef.updateSize('70vw', '100vh');
        }
      })
      const smallDialogSubscription = this.isExtraSmall.subscribe(size => {
        if (size.matches) {
          dialogRef.updateSize('100vw', '100vh');
        } else {
          dialogRef.updateSize('calc(100% - 50px)', '100vh');
        }
      });
      const smallSubscription = this.isSmall.subscribe(size => {
        if (size.matches) {
          dialogRef.updateSize('100vw', '100vh');
        }
      })
      dialogRef.afterClosed().subscribe((data) => {
        mediumDialogSubscription.unsubscribe()
        smallSubscription.unsubscribe()
        smallDialogSubscription.unsubscribe()
      });
    }
    else {
      var jsonObj = {
        "meetingId": meeting.meetingId,
        "userId": localStorage.getItem("userId")
      }

      // var jsonReq = {
      //   "meetingId": meeting.meetingId,
      //   "fkSecUserAttendee": localStorage.getItem("userId")
      // }
      this.meetingService.startMeeting(jsonObj).subscribe((meetingRes: any) => {
        //
        this.sideNav.openInstantMeeting(true);
        var reqJson = { "meetingId": meeting.meetingId, "userId": localStorage.getItem("userId"), "loggedStatus": "LOGIN" }
        this.attendeeService.saveAttendeeLoginflag(jsonObj).subscribe((data: any) => {
     
        })
        this.webTranService.pushUserLoggedInStatus(meeting.meetingId, reqJson).subscribe((data) => {
        });
        this.router.navigate(['schedule'], { queryParams: { "meetingResult": JSON.stringify({ "meetingId": meeting.meetingId, "isMeetingRunning": true, "zoomMeetingId": meeting.zoomMeetingId, "zoomPassword": meeting.zoomPassword }) }, skipLocationChange: true, replaceUrl: false });
      },
        err => {
          //
        });
    }
  }
  joinZoomMeeting(zoomJoinURL: string) {
    window.open(zoomJoinURL, "_blank");
  }
  ngOnInit(): void {
    this.options = {
      month: 'short',
      day: 'numeric',
      year: 'numeric'
    }
    this.isLoading = true;
    this.today = new Date();
    this.currentDate = this.today.toLocaleDateString("en-US", this.options);
    this.meetingDatasource = new MeetingDataSource(this.dashboardService);
    //
    this.meetingJSON.page = 0;
    this.meetingJSON.size = 10;
    if (this.input.nativeElement.value != "") {
      this.meetingJSON.filterTxt = this.input.nativeElement.value;
      this.meetingJSON.filterCol = "meetingTitle";
    }
    localStorage.setItem('upcomingJson', JSON.stringify(this.meetingJSON));
 
    this.meetingDatasource.loadDocumentMeeting(this.meetingJSON);
 

    //
    //

  }

  ngOnChanges() {

  }

  meetingDetails(meetingId: any, isConfidential: any) {
    if (isConfidential == "Y") {
      let meetingStartFlag = 'Y'
      let dialogRef = this.dialog.open(ConfidentialDialogComponent, {
        panelClass: ['animate__animated', 'animate__slideInRight'],
        disableClose: true,
        position: {
          left: "50%"
        },
        maxWidth: "100%",
        maxHeight: "100vh",
        width: "50%",
        data: { isConfidentialCheck: true, meetingId: meetingId, meetingStartFlag: meetingStartFlag }
      })
      const mediumDialogSubscription = this.isMedium.subscribe(size => {
        if (size.matches) {
          dialogRef.updateSize('70vw', '100vh');
        }
      })
      const smallDialogSubscription = this.isExtraSmall.subscribe(size => {
        if (size.matches) {
          dialogRef.updateSize('100vw', '100vh');
        } else {
          dialogRef.updateSize('calc(100% - 50px)', '100vh');
        }
      });
      const smallSubscription = this.isSmall.subscribe(size => {
        if (size.matches) {
          dialogRef.updateSize('100vw', '100vh');
        }
      })
      dialogRef.afterClosed().subscribe((data) => {
        mediumDialogSubscription.unsubscribe()
        smallSubscription.unsubscribe()
        smallDialogSubscription.unsubscribe()
      });
    }
    else {
      this.redirectToMeeting(meetingId);
      this.startMeeting(meetingId);
    }
  }
  redirectToMeeting(meeting: any) {
    this.router.navigate(['schedule'], { queryParams: { "meetingResult": JSON.stringify({ "meetingId": meeting.meetingId, "isMeetingRunning": true, "zoomMeetingId": meeting.zoomMeetingId, "zoomPassword": meeting.zoomPassword }) }, skipLocationChange: true, replaceUrl: false });
  }

  ngAfterViewInit() {
    this.meetingDatasource.counter$
      .pipe(
        tap((cnt) => {
          this.paginator.length = cnt;
        })
      )
      .subscribe();
    fromEvent(this.input.nativeElement, 'keyup')
      .pipe(
        debounceTime(1000),
        distinctUntilChanged(),
        tap(() => {
          this.paginator.pageIndex = 0;
          if (this.completed)
            this.loadPastMeetings()
          else
            this.loadUpcomingMeetings();
        })
      )
      .subscribe();
    this.paginator.page
      .pipe(
        tap(() => {
          if (this.completed)
            this.loadPastMeetings();
          else
            this.loadUpcomingMeetings()

        })
      )
      .subscribe();

  }

  loadUpcomingMeetings() {
    this.meetingJSON.filterTxt = "";
    this.meetingJSON.page = this.paginator.pageIndex;
    this.meetingJSON.size = this.paginator.pageSize;
    if (this.input.nativeElement.value != "") {
      this.meetingJSON.filterTxt = this.input.nativeElement.value;
      this.meetingJSON.filterCol = "meetingTitle";
    } else {
      this.meetingJSON.filterTxt = "";
      this.meetingJSON.filterCol = "";
    }
    this.meetingDatasource.loadDocumentMeeting(this.meetingJSON);
  }
  openPreviousMeetingDailog() {
    var tempConfig: any;
    if (this.deviceLg) {
      tempConfig = this.lg;
    } else if (this.deviceMd) {
      tempConfig = this.md;
    } else if (this.deviceSm) {
      tempConfig = this.sm;
    } else if (this.deviceXs) {
      tempConfig = this.xs;
    } else if (this.deviceXl) {
      tempConfig = this.xl;
    }
    tempConfig["data"] = { "meetingResponse": this.meetingInfoData };
 
    this.dialog.open(PreviousMeetingsComponent, tempConfig);
    this.sideNav.dialogCheckedChecker(true)
  }

  openProjectStatusDialog() {
    if (this.deviceLg) {
      this.dialog.open(ProjectStatusDialogComponent, this.lg)
    }
    if (this.deviceMd) {
      this.dialog.open(ProjectStatusDialogComponent, this.lg)
    }
    if (this.deviceSm) {
      this.dialog.open(ProjectStatusDialogComponent, this.lg)
    }
    if (this.deviceXs) {
      this.dialog.open(ProjectStatusDialogComponent, this.lg)
    }
    if (this.deviceXl) {
      this.dialog.open(ProjectStatusDialogComponent, this.xl)
    }
  }

  openAttachmentNotesDialog(meetingId: number) {
    // alert(meetingId);
    this.meetingService.fetchMeetingInfo(meetingId).subscribe(
      (meetingRes: any) => {
        ////consolee.log("meeting resp" + JSON.stringify(meetingRes));
        this.meetingInfoData = meetingRes.body
        const d = this.dialog.open(ProjectStatusDialogComponent, {
          data: { meetingData: this.meetingInfoData, hide: true },
          panelClass: ['animate__animated', 'animate__slideInRight', 'responsive-class'],
          disableClose: false,
          position: {
            left: "50%"
          },
          maxWidth: "100%",
          maxHeight: "100vh",
          width: "50%",
          height: "100vh"
        })
        const smallDialogSubscription = this.isExtraSmall.subscribe(size => {
          if (size.matches) {
            d.updateSize('100vw', '100vh');
          } else {
            d.updateSize('calc(100% - 50px)', '100vh');
          }
        });
        d.afterClosed().subscribe(() => {
          smallDialogSubscription.unsubscribe();
        });
        // this.commonService.shareDatatoService(this.meetingResponse);
        // this.setData();

        //this.cdr.markForCheck();
        //this.ngxSpinner.hide();
      },
      err => {
        //
        //this.ngxSpinner.hide();
      }).add(() => {
        //Called when operation is complete (both success and error)
      });
  }

  // openAttachmentNotesDialog(){
  //   this.dialog.open(ProjectStatusDialogComponent,{
  //     // disableClose: true
  //     panelClass: ['animate__animated','animate__slideInRight', 'responsive-class'],
  //         disableClose: false,
  //         data : {meetingData : this.meetingInfoData,hide : true},
  //         position : {
  //           left : "50%"
  //         },
  //         maxWidth: "100%",
  //         maxHeight: "100vh",
  //         width : "50%",
  //         height : "100vh"
  //   })
  // }

  deleteMeeting(meetingInfo: any) {
    if (meetingInfo.isConfidential == "Y") {
      let dialogRef = this.dialog.open(ConfidentialDialogComponent, {
        panelClass: ['animate__animated', 'animate__slideInRight'],
        disableClose: true,
        position: {
          left: "50%"
        },
        maxWidth: "100%",
        maxHeight: "100vh",
        width: "50%",
        data: { isConfidentialCheck: true, meetingObj: meetingInfo, deleteMeeting: true }
      })
      const mediumDialogSubscription = this.isMedium.subscribe(size => {
        if (size.matches) {
          dialogRef.updateSize('70vw', '100vh');
        }
      })
      const smallDialogSubscription = this.isExtraSmall.subscribe(size => {
        if (size.matches) {
          dialogRef.updateSize('100vw', '100vh');
        } else {
          dialogRef.updateSize('calc(100% - 50px)', '100vh');
        }
      });
      const smallSubscription = this.isSmall.subscribe(size => {
        if (size.matches) {
          dialogRef.updateSize('100vw', '100vh');
        }
      })
      dialogRef.afterClosed().subscribe((data) => {
        mediumDialogSubscription.unsubscribe()
        smallSubscription.unsubscribe()
        smallDialogSubscription.unsubscribe()
      });
    }
    else {
      var accessFlag = this.permissionService.checkUserRightsWithAlert(this.util.featureList.MEETINGS, this.util.permissionType.MODIFY);
      
      if (!accessFlag) {
        return;
      }
      this.matDialogRef = this.dialog.open(DeleteMeetingPopupComponent, {

        data: {
          meetingId: meetingInfo.meetingId
        },
        panelClass: ['animate__animated', 'animate__slideInRight', 'responsive-class'],
        disableClose: false,
        position: {
          left: "50%"
        },
        maxWidth: "100%",
        maxHeight: "100vh",
        width: "50%",
        height: '100vh'
        // disableClose: true

      });
      const mediumDialogSubscription = this.isMedium.subscribe(size => {
        if (size.matches) {
          this.matDialogRef.updateSize('70vw', '100vh');
        }
      })
      const smallDialogSubscription = this.isExtraSmall.subscribe(size => {
        if (size.matches) {
          this.matDialogRef.updateSize('100vw', '100vh');
        } else {
          this.matDialogRef.updateSize('calc(100% - 50px)', '100vh');
        }
      });
      const smallSubscription = this.isSmall.subscribe(size => {
        if (size.matches) {
          this.matDialogRef.updateSize('100vw', '100vh');
        }
      })
      this.matDialogRef.afterClosed().subscribe((data) => {
        this.meetingDatasource.loadDocumentMeeting(this.meetingJSON);
        smallDialogSubscription.unsubscribe();
        smallSubscription.unsubscribe();
        mediumDialogSubscription.unsubscribe();
      });
    }
  }
  toggleFilter(filterName: any) {
    let dateRangeFilter = <HTMLElement>document.getElementById('date-range-filter-doc');
    let searchFilter = <HTMLElement>document.getElementById('search-filter-doc');
    this.paginator.pageIndex = 0;
    switch (filterName) {
      case "search":
        dateRangeFilter.hidden = true;
        searchFilter.hidden = false;
        break;
      case "oneWeek":
        this.startFilterDate = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate() - 6);
        this.endFilterDate = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate())
        var today = new Date();

        this.isShown = true;
        this.docMeetingJSON.startDate = this.startFilterDate;
        this.docMeetingJSON.endDate = this.endFilterDate;
        this.docMeetingJSON.idisplayStart = this.paginator.pageIndex;
        this.docMeetingJSON.idisplayLength = this.paginator.pageSize;
        this.docMeetingJSON.size = this.paginator.pageSize;
        this.meetingDatasource.loadPastMeetings(this.docMeetingJSON);
        dateRangeFilter.hidden = false;
        searchFilter.hidden = true;
        break;
      case "twoWeek":
        this.startFilterDate = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate())
        this.endFilterDate = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate() + 6);
        // this.startFilterDate = new Date();    
        // this.endFilterDate =  new Date(new Date().setDate(new Date().getDate() - (new Date().getDay() - 1) + 6))
        this.isShown = true;
        this.meetingJSON.startDate = this.startFilterDate;
        this.meetingJSON.endDate = this.endFilterDate;
        this.meetingJSON.idisplayStart = this.paginator.pageIndex;
        this.meetingJSON.idisplayLength = this.paginator.pageSize;
        this.meetingJSON.size = this.paginator.pageSize;
        this.meetingDatasource.loadDocumentMeeting(this.meetingJSON);
        dateRangeFilter.hidden = false;
        searchFilter.hidden = true;
        break;
      case "nxtTwoWeek":
        this.startFilterDate = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate())
        this.endFilterDate = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate() + 13);
        // this.startFilterDate = new Date();    
        // this.endFilterDate =  new Date(new Date().setDate(new Date().getDate() - (new Date().getDay() - 1) + 12))
        this.isShown = true;
        this.meetingJSON.startDate = this.startFilterDate;
        this.meetingJSON.endDate = this.endFilterDate;
        this.meetingJSON.idisplayStart = this.paginator.pageIndex;
        this.meetingJSON.idisplayLength = this.paginator.pageSize;
        this.meetingJSON.size = this.paginator.pageSize;
        this.meetingDatasource.loadDocumentMeeting(this.meetingJSON);
        dateRangeFilter.hidden = false;
        searchFilter.hidden = true;
        break;
      case "dateRange":
        // this.triggerRefresh()
        this.isShown = true;
        document.getElementById('calendar-click-icon-doc')?.click();
        this.startFilterDate = "";
        this.endFilterDate = "";
        dateRangeFilter.hidden = false;
        searchFilter.hidden = true;
        break;
    }
  }
  cancelMeetingPopup(meetingInfo: any) {
 
    if (meetingInfo.isConfidential == "Y") {
      let dialogRef = this.dialog.open(ConfidentialDialogComponent, {
        panelClass: ['animate__animated', 'animate__slideInRight'],
        disableClose: true,
        position: {
          left: "50%"
        },
        maxWidth: "100%",
        maxHeight: "100vh",
        width: "50%",
        data: { isConfidentialCheck: true, meetingObj: meetingInfo, meetingCancelled: true }
      })
      const mediumDialogSubscription = this.isMedium.subscribe(size => {
        if (size.matches) {
          dialogRef.updateSize('70vw', '100vh');
        }
      })
      const smallDialogSubscription = this.isExtraSmall.subscribe(size => {
        if (size.matches) {
          dialogRef.updateSize('100vw', '100vh');
        } else {
          dialogRef.updateSize('calc(100% - 50px)', '100vh');
        }
      });
      const smallSubscription = this.isSmall.subscribe(size => {
        if (size.matches) {
          dialogRef.updateSize('100vw', '100vh');
        }
      })
      dialogRef.afterClosed().subscribe((data) => {
        mediumDialogSubscription.unsubscribe()
        smallSubscription.unsubscribe()
        smallDialogSubscription.unsubscribe()
      });
    }
    else {

      var accessFlag = this.permissionService.checkUserRightsWithAlert(this.util.featureList.CANCALMEETING, this.util.permissionType.ADD);
 
      if (!accessFlag) {
        return;
      }
      this.matDialogCancel = this.dialog.open(CancelMeetingPopupComponent, {

        data: {
          meetingId: meetingInfo.meetingId
        },
        position: {
          left: "50%"
        },
        panelClass: ['animate__animated', 'animate__slideInRight'],
        disableClose: false,
        maxWidth: "100%",
        maxHeight: "100vh",
        height: "100vh",
        width: "50%"
        // disableClose: true

      });
      const mediumDialogSubscription = this.isMedium.subscribe(size => {
        if (size.matches) {
          this.matDialogCancel.updateSize('70vw', '100vh');
        }
      })
      const smallDialogSubscription = this.isExtraSmall.subscribe(size => {
        if (size.matches) {
          this.matDialogCancel.updateSize('100vw', '100vh');
        } else {
          this.matDialogCancel.updateSize('calc(100% - 50px)', '100vh');
        }
      });
      const smallSubscription = this.isSmall.subscribe(size => {
        if (size.matches) {
          this.matDialogCancel.updateSize('100vw', '100vh');
        }
      })
      this.matDialogCancel.afterClosed().subscribe((data) => {
        mediumDialogSubscription.unsubscribe();
        smallDialogSubscription.unsubscribe();
        smallSubscription.unsubscribe()
        this.meetingDatasource.loadDocumentMeeting(this.meetingJSON);
        // this.meetingDatasource.loadPastMeetings(pastMeetJson);
        this.router.routeReuseStrategy.shouldReuseRoute = () => false;
        this.router.onSameUrlNavigation = 'reload';
        this.router.navigate(['dashboard']);

      });
    }
  }

  async openLinkMeeting(meetingInfo: any) {
    this.sideNav.dialogCheckedChecker(true);
    if (meetingInfo.isConfidential == "Y") {
      let dialogRef = this.dialog.open(ConfidentialDialogComponent, {
        panelClass: ['animate__animated', 'animate__slideInRight'],
        disableClose: true,
        position: {
          left: "50%"
        },
        maxWidth: "100%",
        maxHeight: "100vh",
        width: "50%",
        data: { isConfidentialCheck: true, meetingObj: meetingInfo, linkMeetings: true }
      })
      const mediumDialogSubscription = this.isMedium.subscribe(size => {
        if (size.matches) {
          dialogRef.updateSize('70vw', '100vh');
        }
      })
      const smallDialogSubscription = this.isExtraSmall.subscribe(size => {
        if (size.matches) {
          dialogRef.updateSize('100vw', '100vh');
        } else {
          dialogRef.updateSize('calc(100% - 50px)', '100vh');
        }
      });
      const smallSubscription = this.isSmall.subscribe(size => {
        if (size.matches) {
          dialogRef.updateSize('100vw', '100vh');
        }
      })
      dialogRef.afterClosed().subscribe((data) => {
        mediumDialogSubscription.unsubscribe()
        smallSubscription.unsubscribe()
        smallDialogSubscription.unsubscribe()
      });
    }
    else {
      if (meetingInfo.isDummyLink != null && meetingInfo.isDummyLink == "Y") {
        await this.createRecurChildMeeting(meetingInfo).then((res: any) => {
          this.openLinkMeetingDialog(res.body);
        });
      } else {
        this.openLinkMeetingDialog(meetingInfo);
      }

    }
  }
  openLinkMeetingDialog(meetingInfo: any) {
    const previousDialog = this.dialog.open(PreviousMeetingsComponent, {
      data: { meetingResponse: meetingInfo },
      panelClass: ['animate__animated', 'animate__slideInRight', 'rogowclass'],
      disableClose: false,
      position: {
        left: "50%"
      },
      maxWidth: "100%",
      maxHeight: "100vh",
      width: "50%",
      height: "100vh"
    })
    const mediumDialogSubscription = this.isMedium.subscribe(size => {
      if (size.matches) {
        previousDialog.updateSize('100vw', '100vh');
      }
    })
    const smallDialogSubscription = this.isExtraSmall.subscribe(size => {
      if (size.matches) {
        previousDialog.updateSize('100vw', '100vh');
      } else {
        previousDialog.updateSize('calc(100% - 50px)', '100vh');
      }
    });
    const smallSubscription = this.isSmall.subscribe(size => {
      if (size.matches) {
        previousDialog.updateSize('100vw', '100vh');
      }
    })
    previousDialog.afterClosed().subscribe(() => {
      smallDialogSubscription.unsubscribe();
      smallSubscription.unsubscribe();
      mediumDialogSubscription.unsubscribe();
      this.sideNav.dialogCheckedChecker(false)
    });
  }


  //method is used to schedule meeting from dashboard
  scheduleMeeting(meetingInfo: any) {
    if (meetingInfo.isConfidential == "Y") {
      let dialogRef = this.dialog.open(ConfidentialDialogComponent, {
        panelClass: ['animate__animated', 'animate__slideInRight'],
        disableClose: true,
        position: {
          left: "50%"
        },
        maxWidth: "100%",
        maxHeight: "100vh",
        width: "50%",
        data: { isConfidentialCheck: true, meetingObj: meetingInfo, scheduleMeeting: true }
      })
      const mediumDialogSubscription = this.isMedium.subscribe(size => {
        if (size.matches) {
          dialogRef.updateSize('70vw', '100vh');
        }
      })
      const smallSubscription = this.isSmall.subscribe(size => {
        if (size.matches) {
          dialogRef.updateSize('100vw', '100vh');
        }
      })
      const smallDialogSubscription = this.isExtraSmall.subscribe(size => {
        if (size.matches) {
          dialogRef.updateSize('100vw', '100vh');
        }
      });
      dialogRef.afterClosed().subscribe((data) => {
        mediumDialogSubscription.unsubscribe()
        smallSubscription.unsubscribe()
        smallDialogSubscription.unsubscribe()
      });
    }
    else {
      var reqJson = {
        "meetingId": meetingInfo.meetingId,
        "userId": this.globals.userId,
        "visitorTimeZone": this.globals.vTimeZone
      }
      if (this.util.nvl(meetingInfo.meetingFrequency) != "" && this.util.nvl(meetingInfo.meetingFrequency) != "N" && this.util.nvl(meetingInfo.recurVisibleFlag) == "" && this.util.nvl(meetingInfo.recurTillDateAsMilliSec) != "") {
        this.createRecurParentMeeting(reqJson);
      } else {
        this.meetingService.scheduleMeeting(reqJson).subscribe(res => {
          this.meetingDatasource.loadDocumentMeeting(this.meetingJSON);
          this.sideNav.alertSchedule("schedule");
        });
      }
    }
  }

  createRecurParentMeeting(meetingJSON: any) {
    // var reqJson ={
    //   "meetingId":meetingJSON.meetingId,
    //   "userId": this.globals.userId,
    //   "visitorTimeZone":this.globals.vTimeZone
    // }
    this.spinner.show();
    this.meetingService.createRecurParentMeeting(meetingJSON).subscribe(res => {
      this.meetingService.scheduleMeeting(meetingJSON).subscribe(res => {
        this.meetingDatasource.loadDocumentMeeting(this.meetingJSON);
        this.sideNav.alertSchedule("schedule");
      });
    }).add(() => {
      this.spinner.hide();
    });
  }

  // method used to reschedule meeting from dashboard
  reScheduleMeetingPopup(meetingInfo: any) {
    var accessFlag = this.permissionService.checkUserRightsWithAlert(this.util.featureList.POSTPONEMEETING, this.util.permissionType.READ);
    
    if (!accessFlag) {
      return;
    }

    if (meetingInfo.isConfidential == "Y") {
      let dialogRef = this.dialog.open(ConfidentialDialogComponent, {
        panelClass: ['animate__animated', 'animate__slideInRight'],
        disableClose: true,
        position: {
          left: "50%"
        },
        maxWidth: "100%",
        maxHeight: "100vh",
        width: "50%",
        data: { isConfidentialCheck: true, meetingObj: meetingInfo, meetingResheduleFlag: true }
      })
      const mediumDialogSubscription = this.isMedium.subscribe(size => {
        if (size.matches) {
          dialogRef.updateSize('70vw', '100vh');
        }
      })
      const smallDialogSubscription = this.isExtraSmall.subscribe(size => {
        if (size.matches) {
          dialogRef.updateSize('100vw', '100vh');
        } else {
          dialogRef.updateSize('calc(100% - 50px)', '100vh');
        }
      });
      const smallSubscription = this.isSmall.subscribe(size => {
        if (size.matches) {
          dialogRef.updateSize('100vw', '100vh');
        }
      })
      dialogRef.afterClosed().subscribe((data) => {
        mediumDialogSubscription.unsubscribe()
        smallSubscription.unsubscribe()
        smallDialogSubscription.unsubscribe()
      });
    }
    else {
      this.reScheduleMeeting(meetingInfo);
    }
  }
  reScheduleMeeting(meetingInfo: any) {
    this.matDialogReference = this.matDialog.open(ScheduleMeetingPopupComponent, {
      data: { meetingData: meetingInfo },
      // disableClose: true
      panelClass: ['animate__animated', 'animate__slideInRight', 'responsive-class'],
      disableClose: false,
      position: {
        left: "50%"
      },
      maxWidth: "100%",
      maxHeight: "100vh",
      width: "50%",
      height: "100vh"
    });
    const mediumDialogSubscription = this.isMedium.subscribe(size => {
      if (size.matches) {
        this.matDialogReference.updateSize('70vw', '100vh');
      }
    })
    const smallDialogSubscription = this.isExtraSmall.subscribe(size => {
      if (size.matches) {
        this.matDialogReference.updateSize('100vw', '100vh');
      } else {
        this.matDialogReference.updateSize('calc(100% - 50px)', '100vh');
      }
    });
    const smallSubscription = this.isSmall.subscribe(size => {
      if (size.matches) {
        this.matDialogReference.updateSize('100vw', '100vh');
      }
    })
    this.matDialogReference.afterClosed().subscribe((data: any) => {
      smallDialogSubscription.unsubscribe();
      mediumDialogSubscription.unsubscribe();
      smallSubscription.unsubscribe()
      this.meetingDatasource.loadDocumentMeeting(this.meetingJSON);

    });
  }
  triggerRefresh(num: number) {
    if (this.completed) {
      if (num == 0) {
        this.input.nativeElement.value = "";
        this.calendar.reset();
        this.startFilterDate = "";
        this.endFilterDate = "";
        this.meetingDatasource = new MeetingDataSource(this.dashboardService);
        this.docMeetingJSON.idisplayStart = 0;
        this.docMeetingJSON.idisplayLength = ((this.sideNavService.returnExpandFullScreeBooleanSetter() && this.deviceXl) || (this.sideNavService.returnExpandFullScreeBooleanSetter() && this.deviceLg) ? 20 : 10);
        this.docMeetingJSON.size = ((this.sideNavService.returnExpandFullScreeBooleanSetter() && this.deviceXl) || (this.sideNavService.returnExpandFullScreeBooleanSetter() && this.deviceLg) ? 20 : 10);
        this.docMeetingJSON.filterTxt = this.input.nativeElement.value;
        this.docMeetingJSON.filterCol = "meetingTitle";
        this.docMeetingJSON.startDate = "";
        this.docMeetingJSON.endDate = "";
        this.meetingDatasource.loadPastMeetings(this.docMeetingJSON);
        this.refreshTabs();
        //this.isShownClose = ! this.isShownClose;
        this.toggleFilter('search')
      }
      else {
        this.docMeetingJSON.idisplayLength = ((this.sideNavService.returnExpandFullScreeBooleanSetter() && this.deviceXl) || (this.sideNavService.returnExpandFullScreeBooleanSetter() && this.deviceLg) ? 20 : 10);
        this.docMeetingJSON.size = ((this.sideNavService.returnExpandFullScreeBooleanSetter() && this.deviceXl) || (this.sideNavService.returnExpandFullScreeBooleanSetter() && this.deviceLg) ? 20 : 10);
        this.meetingDatasource.loadPastMeetings(this.docMeetingJSON);
      }
    }
    else {

      if (num == 0) {
        this.input.nativeElement.value = "";
        this.calendar.reset();
        this.startFilterDate = "";
        this.endFilterDate = "";
        this.meetingDatasource = new MeetingDataSource(this.dashboardService);
   
        this.meetingJSON.idisplayStart = 0;
        this.meetingJSON.idisplayLength = ((this.sideNavService.returnExpandFullScreeBooleanSetter() && this.deviceXl) || (this.sideNavService.returnExpandFullScreeBooleanSetter() && this.deviceLg) ? 20 : 10);
        this.meetingJSON.size = ((this.sideNavService.returnExpandFullScreeBooleanSetter() && this.deviceXl) || (this.sideNavService.returnExpandFullScreeBooleanSetter() && this.deviceLg) ? 20 : 10);
        this.meetingJSON.filterTxt = this.input.nativeElement.value;
        this.meetingJSON.filterCol = "meetingTitle";
        this.meetingJSON.startDate = "";
        this.meetingJSON.endDate = "";
        this.meetingDatasource.loadDocumentMeeting(this.meetingJSON);
        this.refreshTabs();
        // this.isShown = !this.isShown;
        this.toggleFilter('search')
      }
      else {
   
        this.meetingJSON.idisplayLength = ((this.sideNavService.returnExpandFullScreeBooleanSetter() && this.deviceXl) || (this.sideNavService.returnExpandFullScreeBooleanSetter() && this.deviceLg) ? 20 : 10);
        this.meetingJSON.size = ((this.sideNavService.returnExpandFullScreeBooleanSetter() && this.deviceXl) || (this.sideNavService.returnExpandFullScreeBooleanSetter() && this.deviceLg) ? 20 : 10);
        this.meetingDatasource.loadDocumentMeeting(this.meetingJSON);
      }

    }
  }


  triggerAlert() {
    if (this.completed) {
      this.isShown = true;
      this.docMeetingJSON.startDate = this.startFilterDate;
      this.docMeetingJSON.endDate = this.endFilterDate;
      this.docMeetingJSON.idisplayStart = this.paginator.pageIndex;
      this.docMeetingJSON.idisplayLength = this.paginator.pageSize;
      this.docMeetingJSON.size = this.paginator.pageSize;
      
      this.meetingDatasource.loadPastMeetings(this.docMeetingJSON);
    }else{
    this.isShown = true;
    this.meetingJSON.startDate = this.startFilterDate;
    this.meetingJSON.endDate = this.endFilterDate;
    this.meetingJSON.idisplayStart = 0;
    this.meetingJSON.idisplayLength = this.paginator.pageSize;
    this.meetingJSON.size = this.paginator.pageSize;
    this.meetingDatasource.loadDocumentMeeting(this.meetingJSON);
    }
  }
  refreshTabs() {
    this.meetingDatasource.counter$
      .pipe(
        tap((count) => {
          this.paginator.length = count;
        })
      )
      .subscribe();
    fromEvent(this.input.nativeElement, 'keyup')
      .pipe(
        debounceTime(150),
        distinctUntilChanged(),
        tap(() => {
          if(this.completed)
            this.loadPastMeetings();
          else
            this.loadUpcomingMeetings();
        })
      )
      .subscribe();
    this.paginator.page
      .pipe(
        tap(() =>{
          if(this.completed)
            this.loadPastMeetings();
          else
            this.loadUpcomingMeetings();
        })  
      )
      .subscribe();
  }
  tabChanged(event:any){
    if(event.index==0){
      this.completed = false;
      this.options = {
        month: 'short',
        day: 'numeric',
        year: 'numeric'
      }
      this.isLoading = true;
      this.today = new Date();
      this.currentDate = this.today.toLocaleDateString("en-US", this.options);
      this.meetingDatasource = new MeetingDataSource(this.dashboardService);
      //
      this.meetingJSON.page = 0;
      this.meetingJSON.size = 10;
      if (this.input.nativeElement.value != "") {
        this.meetingJSON.filterTxt = this.input.nativeElement.value;
        this.meetingJSON.filterCol = "meetingTitle";
      }
      localStorage.setItem('upcomingJson', JSON.stringify(this.meetingJSON));
 
      this.meetingDatasource.loadDocumentMeeting(this.meetingJSON);
      this.refreshTabs();
      this.triggerRefresh(0);
    }else if(event.index==1){
      this.completed = true;
      this.options = {
        month : 'short',
        day : 'numeric',
        year : 'numeric'
      }
      this.isLoading = true;
      this.today = new Date();
      this.currentDate = this.today.toLocaleDateString("en-US",this.options);
      this.meetingDatasource = new MeetingDataSource(this.dashboardService);
      
      this.docMeetingJSON.page = 0;
      this.docMeetingJSON.size = ((this.sideNavService.returnExpandFullScreeBooleanSetter() && this.deviceXl) || (this.sideNavService.returnExpandFullScreeBooleanSetter() && this.deviceLg) ? 20 : 10);
      this.docMeetingJSON.filterTxt = this.input.nativeElement.value;
      this.docMeetingJSON.filterCol = "meetingTitle";
      this.meetingDatasource.loadPastMeetings(this.docMeetingJSON);
      this.refreshTabs();
      this.triggerRefresh(0);
    }
    
  }

  mom() {
    return this.router.navigate(['MoM'])
  }

  LoadCompletedMeetingInfo(meeting:any){
      // this.spinner.show();
      if(meeting.isConfidential=='Y'){
        let dialogRef = this.dialog.open(ConfidentialDialogComponent, {
          panelClass: ['animate__animated', 'animate__slideInRight'],
          disableClose: true,
          position: {
            left: "50%"
          },
          maxWidth: "100%",
          maxHeight: "100vh",
          width: "50%",
          data: { isConfidentialCheck: true, meetingObj: meeting,flag:true,viewMeetingTaskInfo:true}
        })
        const mediumDialogSubscription = this.isMedium.subscribe(size => {
          if(size.matches){
            dialogRef.updateSize('70vw','100vh');
          }
        })
        const smallDialogSubscription = this.isExtraSmall.subscribe(size => {
          if (size.matches) {
            dialogRef.updateSize('100vw', '100vh');
          } else {
            dialogRef.updateSize('calc(100% - 50px)', '100vh');
          }
        });
        const smallSubscription = this.isSmall.subscribe(size => {
          if(size.matches){
            dialogRef.updateSize('100vw', '100vh');
          }
        })
        dialogRef.afterClosed().subscribe((data) => {
          mediumDialogSubscription.unsubscribe()
          smallSubscription.unsubscribe()
          smallDialogSubscription.unsubscribe()
        });
  
      }else{
        this.meetingService.fetchMeetingInfo(meeting.meetingId).subscribe(
          (meetingRes: any) => {
            // this.spinner.hide()
            this.meetingInfoData = meetingRes.body
            const d = this.dialog.open(TableDialogComponent, {
              data: this.meetingInfoData,
              panelClass: ['animate__animated','animate__slideInLeft'],
                      disableClose: true,
                      position : {
                        left : "0%"
                      },
                      maxWidth : "100vw",
                      maxHeight: "100vh",
                      width: "50%",
                      height : "100vh"
            })
            const mediumDialogSubscription = this.isMedium.subscribe(size => {
              if(size.matches){
                d.updateSize('70vw','100vh');
              }
            })
            const smallDialogSubscription = this.isExtraSmall.subscribe(size => {
              if (size.matches) {
                d.updateSize('100vw', '100vh');
              } else {
                d.updateSize('50%', '100vh');
              }
            });
            const smallSubscription = this.isSmall.subscribe(size => {
              if(size.matches){
                d.updateSize('100vw', '100vh');
              }
            })
            d.afterClosed().subscribe(() => {
              smallDialogSubscription.unsubscribe();
              mediumDialogSubscription.unsubscribe();
              smallSubscription.unsubscribe()
            });
          },
          err => {
            //
            //this.ngxSpinner.hide();
          }).add(() => {
            //Called when operation is complete (both success and error)
          });
      }
      
    }


    RedirectToCompletedMeeting(meeting:any){
      var accessFlag = this.permissionService.checkUserRightsWithAlert(this.util.featureList.MEETINGS,this.util.permissionType.MODIFY);
      if(!accessFlag){
        return;
      }
     if(meeting.isConfidential=="Y"){
        let dialogRef = this.dialog.open(ConfidentialDialogComponent, {
          panelClass: ['animate__animated', 'animate__slideInRight'],
          disableClose: true,
          position: {
            left: "50%"
          },
          maxWidth: "100%",
          maxHeight: "100vh",
          width: "50%",
          data: { isConfidentialCheck: true, meetingObj: meeting,flag:true,meetingStartFlag:"N",showMoM : true}
        })
        const mediumDialogSubscription = this.isMedium.subscribe(size => {
          if(size.matches){
            dialogRef.updateSize('70vw','100vh');
          }
        })
        const smallDialogSubscription = this.isExtraSmall.subscribe(size => {
          if (size.matches) {
            dialogRef.updateSize('100vw', '100vh');
          } else {
            dialogRef.updateSize('calc(100% - 50px)', '100vh');
          }
        });
        const smallSubscription = this.isSmall.subscribe(size => {
          if(size.matches){
            dialogRef.updateSize('100vw', '100vh');
          }
        })
        dialogRef.afterClosed().subscribe((data) => {
          mediumDialogSubscription.unsubscribe()
          smallSubscription.unsubscribe()
          smallDialogSubscription.unsubscribe()
        });
      }
      // else if(meeting.momStatus == 'A'){
      //   this.router.navigate(['approvedMeeting'], { queryParams: { "meetingResult": JSON.stringify( {"meetingId" : meeting.meetingId, "showMoM" : true })}, skipLocationChange: true, replaceUrl: false });
      // }
      else{
        this.router.navigate(['schedule'], { queryParams: { "meetingResult": JSON.stringify( {"meetingId" : meeting.meetingId, "showMoM" : true })}, skipLocationChange: true, replaceUrl: false });  
      } 
    }

    loadPastMeetings() {
      this.docMeetingJSON.page=this.paginator.pageIndex;
      this.docMeetingJSON.size=this.paginator.pageSize;
      this.docMeetingJSON.filterTxt = this.input.nativeElement.value;
      this.docMeetingJSON.filterCol = "meetingTitle";
      this.meetingDatasource.loadPastMeetings(this.docMeetingJSON);
    }

    copyMeeting(meeting:any){
    
        var accessFlag = this.permissionService.checkUserRightsWithAlert(this.util.featureList.MEETINGS,this.util.permissionType.MODIFY);
        if(!accessFlag){
          return;
        }
    
        if(meeting.isConfidential=="Y"){
          let dialogRef = this.dialog.open(ConfidentialDialogComponent, {
            panelClass: ['animate__animated', 'animate__slideInRight'],
            disableClose: true,
            position: {
              left: "50%"
            },
            maxWidth: "100%",
            maxHeight: "100vh",
            width: "50%",
            data: { isConfidentialCheck: true, meetingObj: meeting,copyMeeting:true}
          })
          const mediumDialogSubscription = this.isMedium.subscribe(size => {
            if(size.matches){
              dialogRef.updateSize('70vw','100vh');
            }
          })
          const smallDialogSubscription = this.isExtraSmall.subscribe(size => {
            if (size.matches) {
              dialogRef.updateSize('100vw', '100vh');
            } else {
              dialogRef.updateSize('calc(100% - 50px)', '100vh');
            }
          });
          const smallSubscription = this.isSmall.subscribe(size => {
            if(size.matches){
              dialogRef.updateSize('100vw', '100vh');
            }
          })
          dialogRef.afterClosed().subscribe((data) => {
            mediumDialogSubscription.unsubscribe()
            smallSubscription.unsubscribe()
            smallDialogSubscription.unsubscribe()
          });
        }
        else{
        this.matDialogCopy = this.dialog.open(CopymeetingComponent, {
          data:{meeting},
          panelClass: ['animate__animated','animate__slideInLeft'],
          disableClose: false,
          position : {
            left : "0%"
          },
          maxWidth: "100vw",           
          maxHeight: "100vh",
          width: "50%",
          height : "100vh"
        });
        const mediumDialogSubscription = this.isMedium.subscribe(size => {
          if(size.matches){
            this.matDialogCopy.updateSize('70vw','100vh');
          }
        })
        const smallDialogSubscription = this.isExtraSmall.subscribe(size => {
          if (size.matches) {
            this.matDialogCopy.updateSize('100vw', '100vh');
          } else {
            this.matDialogCopy.updateSize('50%', '100vh');
          }
        });
        const smallSubscription = this.isSmall.subscribe(size => {
          if(size.matches){
            this.matDialogCopy.updateSize('100vw', '100vh');
          }
        })
        this.matDialogCopy.afterClosed().subscribe((data)=>{
          this.router.routeReuseStrategy.shouldReuseRoute = () => false;
          this.router.onSameUrlNavigation = 'reload';
          this.router.navigate(['dashboard']);
          smallDialogSubscription.unsubscribe();
          mediumDialogSubscription.unsubscribe();
          smallSubscription.unsubscribe();
        });
      }
      }


      // method used to create Followup meeting from dashboard
        followupPopup(meetingInfo:any){
          this.matDialogRefrence = this.matDialog.open(FollowupMeetingPopupComponent, {
            data : {meetingData : meetingInfo},
            panelClass : "base-class-dialog",
            disableClose: false,
            maxWidth: "100%",
            maxHeight: "100vh",
            width : "50%"
          });
          this.matDialogRef.afterClosed().subscribe((data :any)=>
          { 
      
          });
        }

        toggleFilterComMeeting(filterName : any){
          let dateRangeFilter = <HTMLElement>document.getElementById('date-range-filter-pt');
          let searchFilter = <HTMLElement>document.getElementById('search-filter-pt');
          this.paginator.pageIndex = 0;
          switch(filterName){
            case "search":
              dateRangeFilter.hidden = true;
              searchFilter.hidden = false;
              break;
            case "oneWeek":
              // this.startFilterDate = new Date(new Date().setDate(new Date().getDate() - (new Date().getDay() - 1) - 7));
              this.startFilterDate = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate() - 6);    
              this.endFilterDate =  new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate())
              var today = new Date();
              // var nextweek = new Date(today.getFullYear(), today.getMonth(), today.getDate() - 7);
      
              this.isShown = true;
              // this.meetingJSON.startDate=new Date();
              // this.meetingJSON.endDate=this.endFilterDate;
              this.meetingJSON.startDate=this.startFilterDate;
              this.meetingJSON.endDate=this.endFilterDate;
              this.meetingJSON.idisplayStart=this.paginator.pageIndex;
              this.meetingJSON.idisplayLength=this.paginator.pageSize;
              this.meetingJSON.size=this.paginator.pageSize;
      
              this.meetingDatasource.loadPastMeetings(this.meetingJSON);      
              dateRangeFilter.hidden = false;
              searchFilter.hidden = true;
              break;
            case "twoWeek":
              this.startFilterDate = new Date();    
              this.endFilterDate =  new Date(new Date().setDate(new Date().getDate() - (new Date().getDay() - 1) + 6))
      
              this.isShown = true;
              this.meetingJSON.startDate=new Date();
              this.meetingJSON.endDate=this.endFilterDate;
              this.meetingJSON.idisplayStart=this.paginator.pageIndex;
              this.meetingJSON.idisplayLength=this.paginator.pageSize;
              this.meetingJSON.size=this.paginator.pageSize;
      
              this.meetingDatasource.loadPastMeetings(this.meetingJSON);
              dateRangeFilter.hidden = false;
              searchFilter.hidden = true;
              break;
            case "nxtTwoWeek":
              this.startFilterDate = new Date();    
              this.endFilterDate =  new Date(new Date().setDate(new Date().getDate() - (new Date().getDay() - 1) + 12))
      
              this.isShown = true;
              this.meetingJSON.startDate=new Date();
              this.meetingJSON.endDate=this.endFilterDate;
              this.meetingJSON.idisplayStart=this.paginator.pageIndex;
              this.meetingJSON.idisplayLength=this.paginator.pageSize;
              this.meetingJSON.size=this.paginator.pageSize;
      
              this.meetingDatasource.loadPastMeetings(this.meetingJSON);
              dateRangeFilter.hidden = false;
              searchFilter.hidden = true;
              break;
            case "dateRange":
              // this.triggerRefresh()
              this.isShown = true;
              document.getElementById('calendar-click-icon-pt')?.click()
              this.startFilterDate = "";
              this.endFilterDate = "";
              dateRangeFilter.hidden = false;
              searchFilter.hidden = true;
              break;
          }
        }


        notHeldPopup(meetingInfo:any){
          var accessFlag = this.permissionService.checkUserRightsWithAlert(this.util.featureList.MEETINGS,this.util.permissionType.MODIFY);
          if(!accessFlag){
            return;
          }
    
        if(meetingInfo.isConfidential=="Y"){
          let dialogRef = this.dialog.open(ConfidentialDialogComponent, {
            panelClass: ['animate__animated', 'animate__slideInRight'],
            disableClose: true,
            position: {
              left: "50%"
            },
            maxWidth: "100%",
            maxHeight: "100vh",
            width: "50%",
            data: { isConfidentialCheck: true, meetingObj: meetingInfo,notHeldPop:true}
          })
          const mediumDialogSubscription = this.isMedium.subscribe(size => {
            if(size.matches){
              dialogRef.updateSize('70vw','100vh');
            }
          })
          const smallDialogSubscription = this.isExtraSmall.subscribe(size => {
            if (size.matches) {
              dialogRef.updateSize('100vw', '100vh');
            } else {
              dialogRef.updateSize('calc(100% - 50px)', '100vh');
            }
          });
          const smallSubscription = this.isSmall.subscribe(size => {
            if(size.matches){
              dialogRef.updateSize('100vw', '100vh');
            }
          })
          dialogRef.afterClosed().subscribe((data) => {
            mediumDialogSubscription.unsubscribe()
            smallSubscription.unsubscribe()
            smallDialogSubscription.unsubscribe()
          });
        }
        else{
        this.matDialogNotHeld = this.dialog.open(NotHeldPopupComponent, {
    
          data:{
            meeting:meetingInfo
          },
          panelClass: ['animate__animated','animate__slideInLeft'],
                      disableClose: true,
                      position : {
                        left : "0%"
                      },                  
                      maxWidth: "100%",
                      maxHeight: "100vh",
                      width: "50%",
                      height : "100vh"
    
        });
        const mediumDialogSubscription = this.isMedium.subscribe(size => {
          if(size.matches){
            this.matDialogNotHeld.updateSize('70vw','100vh');
          }
        })
        const smallDialogSubscription = this.isExtraSmall.subscribe(size => {
          if (size.matches) {
            this.matDialogNotHeld.updateSize('100vw', '100vh');
          } else {
            this.matDialogNotHeld.updateSize('50%', '100vh');
          }
        });
        const smallSubscription = this.isSmall.subscribe(size => {
          if(size.matches){
            this.matDialogNotHeld.updateSize('100vw', '100vh');
          }
        })
        this.matDialogNotHeld.afterClosed().subscribe((data)=>{
          this.meetingDatasource.loadPastMeetings(this.meetingJSON);
          smallDialogSubscription.unsubscribe();
          mediumDialogSubscription.unsubscribe();
          smallSubscription.unsubscribe();
        });
      }
      }


       viewMomPdf(meetingInfoData:any){
          if(meetingInfoData.isConfidential=="Y"){
            let dialogRef = this.dialog.open(ConfidentialDialogComponent, {
              panelClass: ['animate__animated', 'animate__slideInRight'],
              disableClose: true,
              position: {
                left: "50%"
              },
              maxWidth: "100%",
              maxHeight: "100vh",
              width: "50%",
              data: { isConfidentialCheck: true, meetingObj: meetingInfoData,viewMomPdfFlag:true}
            })
            const mediumDialogSubscription = this.isMedium.subscribe(size => {
              if(size.matches){
                dialogRef.updateSize('70vw','100vh');
              }
            })
            const smallDialogSubscription = this.isExtraSmall.subscribe(size => {
              if (size.matches) {
                dialogRef.updateSize('100vw', '100vh');
              } else {
                dialogRef.updateSize('calc(100% - 50px)', '100vh');
              }
            });
            const smallSubscription = this.isSmall.subscribe(size => {
              if(size.matches){
                dialogRef.updateSize('100vw', '100vh');
              }
            })
            dialogRef.afterClosed().subscribe((data) => {
              mediumDialogSubscription.unsubscribe()
              smallSubscription.unsubscribe()
              smallDialogSubscription.unsubscribe()
            });
          }
          else{
          let viewMinutes = this.dialog.open(ViewMomDialogComponent,{
            data:{meetingInfo:meetingInfoData},
            panelClass: ['parent-dialog-container'],
            maxWidth : "100%",
            maxHeight : "100vh",
            minWidth : "80%",
            minHeight : "80vh",
          })
          const mediumDialogSubscription = this.isMedium.subscribe(size => {
            if(size.matches){
              viewMinutes.updateSize('70vw','100vh');
            }
          })
          const smallSubscription = this.isSmall.subscribe(size => {
            if(size.matches){
              viewMinutes.updateSize('100vw', '100vh');
            }
          })
          const smallDialogSubscription = this.isExtraSmall.subscribe(size => {
            if (size.matches) {
              viewMinutes.updateSize('100vw', '100vh');
            } 
            // else {
            //   this.matDialogRef.updateSize('50%', '100vh');
            // }
          });
          viewMinutes.afterClosed().subscribe((data)=>{
            mediumDialogSubscription.unsubscribe()
            smallDialogSubscription.unsubscribe()
            smallSubscription.unsubscribe()
          });
        }
        }

}

